<template>
    <div>

        <TextBanner>
        Ein längerer Aufenthalt auf dem Mond ist aber nur eine Etappe der Mission. Der Mond wird Zwischenziel auf dem langen Weg zum Mars.
        </TextBanner>


        <InfoBox modalName="IB_Orion">
            <template #title>Orion – das Transportmodul für die Crew</template>
            <template #subline></template>
            <template>
                <p>Der Transporter erinnert in der Form an die Raumkapsel der Apollo-Missionen aus den 1960er und 70er Jahren. Technisch liegen jedoch Welten dazwischen, und die Kapsel ist deutlich größer. Vier bis sechs Menschen finden darin Platz. 
                    Es ist ein Hightech-Raumschiff, das auch längere Aufenthalte im All möglich macht.</p>
                    
                 <p>Die Esa hat das dazugehörige Versorgungs-Modul entwickelt.</p>

            </template>
        </InfoBox>


        <!-- Fallback -->
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/fallback_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/fallback_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/fallback.jpg" alt="">
            </picture>
            <div class="hotspot" v-on:click="infobox('IB_SLS')"></div>
            <div class="hotspot" v-on:click="infobox('IB_Orion')"></div>
        </Fallback>


    </div>
</template>

<script>
    export default {
        name: 'infobox',
        babylonState: {
            camera: {               
                //moveFunction: 'set',
                position: [1.8,1.85,12],  //  .2,1.2,15]   schräg unten -4.35,2,16.5   nah-oben1.4,1.32,9.5
                target: [-1.4,-.8,-5],  //   -1.5,.7,-1.5    -schräg unten -.5,-.5,-3   nah-oben-1.4,-.8,-5
                radiusLimits: [8,100],    //(11 nächster Abstand ok)
                clipping: [0.2, 100000.0], 
                animationSpeed: .1,   
                fov: 1.5,   //1.2

                // position: [.2,1.2,11],  //von oben [0,1.4,15],  von unten .2,2,15  vonUntenMitErde: [1.17,1.77,29]
                // target: [0,0,-2],  //von oben [0,1.5,-3]  von unten 0,1.5,-3   vonUntenMitErde: [0,-3,-3]
                // radiusLimits: [4,100],  
                // clipping: [0.2, 100000.0], 
                // animationSpeed: .1,   
                // fov: 1.8,   //1.2
 
                useAutoRotationBehavior: true,
                idleRotationSpeed: -0.02,  //0.01
            },



            hotspots: {
                 Info_6: {
                    infoBox: 'IB_Orion',
                    visible: true,
                    //renderingGroupId:1,
                    position: [-1.6, .5, -6.7],   //1, 2, -7
                    scale: 2,

                    trigger: (babylonController) => { 
                            babylonController.moveCamera(.2,1.2,10,0,-1.5,-7);                      
                    },
                }
           },

            artemis_geo:{
                scaling: [1,1,-1],
                pickable: false,

                Label_Gateway: {
                    Text_Gateway:{
                        renderingGroupId:0
                    },
                    fade: false,
                    visible: false,
                    renderingGroupId: 0,
                    billboardMode: 7,
                },

                Erde_Plane:{
                    pickable: false,
                    fade:true,
                    visible: true
                    },

                Station_All:{
                    //pickable:false,
                    //renderingGroupId:2,
                    Empty:{
                        Power:{ 
                            pickable: false,
                        },
                        Logistics:{
                            pickable: false
                        },
                        Airlock:{
                            pickable: false
                        },
                        Lander:{
                            pickable: false
                        },
                        Halo:{
                            pickable: false
                        },
                        Habitation:{
                            pickable: false
                        },
                        Esprit:{
                            pickable: false
                        },
                        Canadarm:{
                            pickable: false
                        },

                        Orion:{
                            visible: true
                        },

                            // Orion:{
                            //     pickable: false,
                            //     Label_Orion:{
                            //         Text_Orion:{
                            //             //renderingGroupId:2
                            //         },
                            //         //renderingGroupId:2,
                            //         visible: true,
                            //         billboardMode: 7,
                            //         }
                            //     }
                    }
                },  

                Sonne: {
                    fade: true,
                    visible: true
                    },
                Mars: {
                    visible: false,
                    fade: true,
                },
                 Weltall: {       
                    pickable: false,
                    visible: true,
                    fade: false,
                    },

            },
           
        },
        babylonReady: function () {

        // this.$babylonController.timer.add(4500, () => {
        //     this.$babylonController.setCameraRadiusLimit(6,100);
        // });

        this.$babylonController.goToAnimation("anim_orion_ankommen", 1);
        this.$babylonController.startAnimation("anim_orion_ankommen", false, .07); //.1


        this.$babylonController.goToAnimation("anim_power", 0);
        this.$babylonController.goToAnimation("anim_lander", 0);
        this.$babylonController.goToAnimation("anim_canadarm", 0);
        this.$babylonController.goToAnimation("anim_logistics", 0);
        this.$babylonController.goToAnimation("anim_habitation", 0);
        this.$babylonController.goToAnimation("anim_orion", 0);
        this.$babylonController.goToAnimation("anim_esprit", 0);
        this.$babylonController.goToAnimation("anim_halo", 0);
        this.$babylonController.goToAnimation("anim_airlock", 0);

        },
    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {

        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);
        }
    }


</style>
